<template>
  <form
    ref="form"
    class="visit-diary-template"
    v-on:submit.prevent="onSubmit"
  >
    <modal-dialog
      max-width="auto"
      scrollable
      title="Болезни полости рта, слюнных желёз и челюстей (МКБ-10)"
      v-model="showDiseasesDialog"
      with-cross
    >
      <select-item-tree-dialog
        v-bind:fetch-children="fetchDiseaseChildren"
        v-bind:items="diseaseTree"
        v-on:change="onChangeIcdModal"
        v-on:created="fetchDiseaseCategories"
      />
      <template v-slot:actions>
        <button
          class="visit-diary-template__button remove"
          type="button"
          v-on:click="showDiseasesDialog = false"
        >Закрыть</button>
      </template>
    </modal-dialog>
    <autocomplete-input
      label="Категория"
      v-bind:items="categoryList"
      v-bind:violations="categoryErrors"
      v-bind:aria-invalid="!!categoryErrors.length"
      item-text="name"
      item-value="id"
      v-model="categoryId" />
    <popover-menu>
      <template v-slot:trigger="{ listenerObject }">
        <div
          class="visit-diary-template tooth"
          title="Выберите зубы"
          v-on="listenerObject"
          v-if="shownToothIconDiary">
          Выберите зубы:
        </div>
        <div
          class="visit-diary-template__text"
          title="Выберите зубы"
          v-on="listenerObject"
          v-else>
          Выберите зубы:
          <span>{{ teethTextDiary }}</span>
        </div>
      </template>
      <teeth-select-popup
        v-on:submit="onSubmitTeethDiary(...arguments)"
        v-bind:initial-selected="teeth"
        v-bind:initial-dental-parts="dentalParts"
      />
    </popover-menu>
    <input-text
      v-model="name"
      v-bind:disabled="disabled"
      name="name"
      required="required"
      title="Название" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      key="diagnosis"
      v-model="diagnosis"
      name="diagnosis"
      placeholder="Клинический диагноз"
      title="Клинический диагноз"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:show-counter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="complaints"
      name="complaints"
      placeholder="Жалобы"
      title="Жалобы"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:show-counter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="generalAnalysis"
      name="general_analysis"
      placeholder="Общий анамнез"
      title="Общий анамнез"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="dentalAnamnesis"
      name="dental_anamnesis"
      placeholder="Анамнез стоматологический"
      title="Анамнез стоматологический"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="objectively"
      name="objectively"
      placeholder="Объективный статус"
      title="Объективный статус"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="statusLokalis"
      name="status_lokalis"
      placeholder="Локальный статус"
      title="Локальный статус"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="studies"
      name="studies"
      placeholder="Исследования"
      title="Исследования"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="treatment"
      name="treatment"
      placeholder="Лечение"
      title="Лечение"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="recommendations"
      name="recommendations"
      placeholder="Рекомендации"
      title="Рекомендации"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <textarea-length-limitation
      v-bind:disabled="disabled"
      v-model="guarantees"
      name="guarantees"
      placeholder="Гарантии"
      title="Гарантии"
      rows="4"
      v-bind:max-length="$options.textFieldMaxLength"
      v-bind:showCounter="false" />
    <div class="visit-diary-template__group">
      МКБ-10
      <v-autocomplete
        v-bind:disabled="disabled"
        attach
        append-icon=""
        background-color="white"
        class="icd__search visit-diary-template__search"
        height="40px"
        hide-details
        item-text="name"
        item-value="id"
        name="icd_id"
        v-bind:clearable="true"
        v-bind:items="diseases"
        v-bind:loading="isDiseasesLoad"
        v-bind:outlined="true"
        v-model="icdId"
        v-on:input="onChangeIcd"
        v-on:update:search-input="onUpdateQueryDisease">
        <template v-slot:append-outer>
          <button
            type="button"
            v-on:click="onShowDiseasesDialog()"
            class="visit-diary-template__icon-file" />
        </template>
        <template v-slot:no-data>
          <p style="padding: 10px; margin:0;">{{ diseaseNoDataText }}</p>
        </template>
      </v-autocomplete>
    </div>
    <input-checkbox
      v-bind:disabled="disabled"
      v-bind:title="'Санирован'"
      v-model="sanitized"
    />
    <div class="visit-diary-template__buttons">
      <button
        type="submit"
        class="visit-diary-template__button save">
        Сохранить
      </button>
      <slot name="buttons" />
    </div>
  </form>
</template>
<script>
import InputText from '@/components/InputText.vue';
import SelectItemTreeDialog from '@/components/SelectItemTreeDialog.vue';
import TextareaLengthLimitation from '@/components/TextareaLengthLimitation.vue';
import formMixin from '@/mixins/formMixin';
import teethGroupMixin from '@/mixins/teethGroupMixin';
import InputCheckbox from '@/components/InputCheckbox.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import TeethSelectPopup from '@/components/TeethSelectPopup.vue';
import { DiaryTemplateCreationRequest } from '@/storage/gateways/VisitGateway';
import AutocompleteInput from '@/components/AutocompleteInput.vue';
import diseaseMixin from '@/mixins/diseaseMixin';
import ModalDialog from './ModalDialog.vue';

/**
 * @description Разрешить получение списка ошибок для поля ввода.
 * @param {string} cause Имя поля ввода.
 * @returns {function}
 */
const resolveInputErrors = (cause) => (vm) => (
  cause in vm.inputErrors ? vm.inputErrors[cause] : []
);

/**
 * @description Форма шаблона протокола приема.
 * @type {Vue}
 */
export default {
  components: {
    ModalDialog,
    AutocompleteInput,
    TeethSelectPopup,
    PopoverMenu,
    InputCheckbox,
    InputText,
    TextareaLengthLimitation,
    SelectItemTreeDialog,
  },
  computed: {
    categoryErrors: resolveInputErrors('input_category_id'),
    /**
     * @description Показывать иконку зуба.
     * @type {boolean}
     */
    shownToothIconDiary() {
      return this.teeth.length + this.dentalParts.length === 0;
    },
    diseaseNoDataText() {
      if (this.isDiseasesLoad) {
        return 'Идет поиск';
      }
      if (this.queryDisease === '') {
        return 'Введите текст';
      }
      return 'Результатов нет';
    },
    diseases() {
      if (this.initialIcdId === '' || this.initialIcdName === '') {
        return this.diseaseList;
      }
      const initialDisease = { id: this.icdId, name: this.icdName };
      return Array.of(initialDisease, ...this.diseaseList);
    },
    /**
     * @description Текстовый список зубов.
     * @type {string}
     */
    teethTextDiary() {
      const segments = this.groupTeethInSegments(this.teeth);
      const parts = this.dentalParts.map(({ title }) => title);
      const partSegments = parts.join(', ');
      return [segments, partSegments].filter((segment) => segment !== '').join(', ');
    },
  },
  data() {
    return {
      categoryId: this.initialCategoryId,
      complaints: this.initialComplaints,
      dentalAnamnesis: this.initialDentalAnamnesis,
      diagnosis: this.initialDiagnosis,
      generalAnalysis: this.initialGeneralAnalysis,
      guarantees: this.initialGuarantees,
      icdId: this.initialIcdId,
      icdName: this.initialIcdName,
      name: this.initialName,
      objectively: this.initialObjectively,
      prognosis: this.initialPrognosis,
      queryDisease: this.initialQueryDisease,
      recommendations: this.initialRecommendations,
      statusLokalis: this.initialStatusLokalis,
      studies: this.initialStudies,
      treatment: this.initialTreatment,
      sanitized: this.initialSanitized,
      teeth: this.initialTeeth,
      dentalParts: this.initialDentalParts,
    };
  },
  methods: {
    /**
     * @description Обработать ввод зубов
     * @param {int[]}  teeth        Номера зубов.
     * @param {any[]}  dentalParts  Стоматологические части.
     * @returns {void}
     */
    onSubmitTeethDiary(teeth, dentalParts) {
      this.teeth = teeth;
      this.dentalParts = dentalParts;
    },
    /**
     * @description Обработать событие отправки формы.
     */
    onSubmit() {
      const request = this.makeRequest();
      this.$emit('submit', request);
    },
    /**
     * @description Создать запрос на создание шаблона проктокола приема.
     * @returns {Object}
     */
    makeRequest() {
      return new DiaryTemplateCreationRequest(
        this.id,
        this.name,
        this.categoryId,
        this.complaints,
        this.dentalAnamnesis,
        this.diagnosis,
        this.generalAnalysis,
        this.guarantees,
        this.icdId,
        this.objectively,
        this.prognosis,
        this.recommendations,
        this.statusLokalis,
        this.studies,
        this.treatment,
        this.teeth,
        this.dentalParts,
        this.sanitized,
      );
    },
    /**
     * @description Обработать изменение болезни МКБ-10
     * @param {string} icdId
     */
    onChangeIcd(icdId) {
      const disease = this.diseaseList.find((item) => item.id === icdId);
      this.icdId = icdId;
      this.icdName = disease?.name ?? '';
    },
    /**
     * @description Обработать изменение МКБ.
     * @param {Object} item
     * @returns {void}
     */
    onChangeIcdModal(item) {
      if (!this.diseaseList.find((elem) => elem.id === item.id)) {
        this.$emit('query-disease', item?.name);
      }
      this.icdId = item.id;
      this.icdName = item?.name ?? '';
      this.showDiseasesDialog = false;
    },
    onUpdateQueryDisease(updatedValue) {
      const query = updatedValue || '';
      this.queryDisease = query;
      if (query === '' || query.length > 500) {
        return;
      }
      const disease = this.diseaseList.find((item) => item.name === query);
      if (disease && disease.id === this.icdId) {
        return;
      }
      this.$emit('query-disease', query);
    },
    /**
     * @description Показ диалога выбора мкб
     */
    onShowDiseasesDialog() {
      this.showDiseasesDialog = true;
    },
  },
  mixins: [
    formMixin,
    teethGroupMixin,
    diseaseMixin,
  ],
  name: 'FormVisitDiaryTemplate',
  props: {
    categoryList: { type: Array, required: true },
    diseaseList: { type: Array, required: true },
    id: {
      type: [String, Number],
      default: () => null,
    },
    initialCategoryId: {
      default: () => null,
      type: Number,
    },
    initialComplaints: {
      default: () => '',
      type: String,
    },
    initialDentalAnamnesis: {
      default: () => '',
      type: String,
    },
    initialDiagnosis: {
      default: () => '',
      type: String,
    },
    initialGeneralAnalysis: {
      default: () => '',
      type: String,
    },
    initialGuarantees: {
      default: () => '',
      type: String,
    },
    initialIcdId: {
      default: () => '',
      type: String,
    },
    initialIcdName: {
      default: () => '',
      type: String,
    },
    initialName: {
      default: () => '',
      type: String,
    },
    initialObjectively: {
      default: () => '',
      type: String,
    },
    initialPrognosis: {
      default: () => '',
      type: String,
    },
    initialQueryDisease: {
      default: () => '',
      type: String,
    },
    initialRecommendations: {
      default: () => '',
      type: String,
    },
    initialStatusLokalis: {
      default: () => '',
      type: String,
    },
    initialStudies: {
      default: () => '',
      type: String,
    },
    initialTreatment: {
      default: () => '',
      type: String,
    },
    isDiseasesLoad: Boolean,
    initialSanitized: {
      default: () => false,
      type: Boolean,
    },
    initialTeeth: {
      default: () => [],
      type: Array,
    },
    initialDentalParts: {
      default: () => [],
      type: Array,
    },
    disabled: {
      default: () => false,
      type: Boolean,
    },
    /**
     * @description Список нарушений ограничений.
     * @type {Object}
     */
    inputErrors: {
      type: Object,
      required: true,
    },
  },
  textFieldMaxLength: 10000,
};
</script>
<style lang="scss">
@use "@/scss/buttons";
.visit-diary-template {
  display: flex;
  flex-direction: column;
  gap: 36px;
  &__group {
    color: #90A0B7;
    display: flex;
    flex-direction: column;
    gap: 3px;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
  }
  &__search {
    max-width: 100%;
    position: relative;
    & .v-input__slot {
      min-height: 40px !important;
      & > .v-select__slot {
        & > .v-input__append-inner {
          margin-top: 7px !important;
          margin-left: 25px !important;
        }
      }
    }
    & .v-list-item__title {
      white-space: normal;
    }
    fieldset {
      border: 1px solid #C2CFE0;
    }
  }
  &__icon-file {
    position: absolute;
    right: 11px !important;
    top: 2px !important;
    background-repeat: no-repeat;
    background-image: url("@/assets/img/file.svg");
    background-position: center;
    background-color: #eaeff3;
    border-radius: 0 3px 3px 0;
    width: 37px;
    height: 36px;
  }
  &.tooth {
    display: flex;
    align-items: center;
    flex-direction: row;
    gap: 20px;
    color: #0489e0;
    cursor: pointer;
    white-space: nowrap;
    &:after {
      content: '';
      background-image: url("@/assets/img/tooth.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 100%;
      height: 30px;
    }
    &:hover {
      color: #192a3e;
    }
  }
}
.visit-diary-template .visit-diary-template__submit {
  @include buttons.btn-blue(8rem, 2rem, 1rem);
}

.visit-diary-template__buttons {
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  gap: 16px;
}

.visit-diary-template__text {
  color: #000000;
  span {
    color: #0489e0;
    cursor: pointer;
    &:hover {
      color: #192a3e;
    }
  }
}

.visit-diary-template__button {
  &.save {
    @include buttons.btn-blue(207px, 48px, 16px);
  }
  &.remove {
    @include buttons.btn-transparent(207px, 48px, 16px);
  }
}
</style>
